export interface CartItem {
  id: string;
  productId: string;
  title: string;
  image: string;
  price: number;
  originalPrice: number;
  seller: string;
  sellerId: string;
  quantity: number;
  commission?: number;
  referralCode?: string;
}

export const mockCartItems: CartItem[] = [
  {
    id: "ci1",
    productId: "1",
    title: "Premium Wireless Earbuds Pro X200",
    image: "https://public.readdy.ai/ai/img_res/21255a2c1532bd7ae16d4cc60225bf53.jpg",
    price: 49.99,
    originalPrice: 89.99,
    seller: "TechVision Factory",
    sellerId: "techvision",
    quantity: 1,
    commission: 12,
  },
  {
    id: "ci2",
    productId: "4",
    title: "Vitamin C Brightening Serum 30ml",
    image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20glass%20bottle%20skincare%20product%20clean%20white%20background%20minimalist%20photography&width=400&height=400&seq=prod4&orientation=squarish",
    price: 19.99,
    originalPrice: 38.00,
    seller: "PureGlow Labs",
    sellerId: "pureglow",
    quantity: 2,
    commission: 15,
  },
  {
    id: "ci3",
    productId: "8",
    title: "Resistance Bands Set 5-Level",
    image: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%20colorful%20five%20levels%20fitness%20exercise%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod8&orientation=squarish",
    price: 16.99,
    originalPrice: 29.99,
    seller: "FitForge Manufacturing",
    sellerId: "fitforge",
    quantity: 1,
    commission: 8,
  },
];

export const mockReferralLinks = [
  {
    id: "rl1",
    productId: "1",
    productTitle: "Premium Wireless Earbuds Pro X200",
    productImage: "https://readdy.ai/api/search-image?query=premium%20wireless%20earbuds%20white%20clean%20product%20photography%20on%20white%20background%20minimalist%20studio%20lighting&width=400&height=400&seq=prod1&orientation=squarish",
    seller: "TechVision Factory",
    sellerId: "techvision",
    commission: 12,
    price: 49.99,
    referralCode: "REF-JESS-001",
    referralUrl: "https://starbookprime.com/product/1?ref=REF-JESS-001",
    clicks: 1842,
    conversions: 94,
    earnings: 564.06,
    pendingEarnings: 119.76,
    createdAt: "2026-03-01",
    lastClick: "2026-04-12",
    trend: "up",
    weeklyClicks: [120, 145, 198, 210, 265, 310, 290],
  },
  {
    id: "rl2",
    productId: "4",
    productTitle: "Vitamin C Brightening Serum 30ml",
    productImage: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20glass%20bottle%20skincare%20product%20clean%20white%20background%20minimalist%20photography&width=400&height=400&seq=prod4&orientation=squarish",
    seller: "PureGlow Labs",
    sellerId: "pureglow",
    commission: 15,
    price: 19.99,
    referralCode: "REF-JESS-002",
    referralUrl: "https://starbookprime.com/product/4?ref=REF-JESS-002",
    clicks: 3210,
    conversions: 218,
    earnings: 653.87,
    pendingEarnings: 89.96,
    createdAt: "2026-02-14",
    lastClick: "2026-04-12",
    trend: "up",
    weeklyClicks: [280, 310, 420, 390, 510, 480, 520],
  },
  {
    id: "rl3",
    productId: "8",
    productTitle: "Resistance Bands Set 5-Level",
    productImage: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%20colorful%20five%20levels%20fitness%20exercise%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod8&orientation=squarish",
    seller: "FitForge Manufacturing",
    sellerId: "fitforge",
    commission: 8,
    price: 16.99,
    referralCode: "REF-JESS-003",
    referralUrl: "https://starbookprime.com/product/8?ref=REF-JESS-003",
    clicks: 987,
    conversions: 41,
    earnings: 55.64,
    pendingEarnings: 13.59,
    createdAt: "2026-03-20",
    lastClick: "2026-04-11",
    trend: "down",
    weeklyClicks: [90, 110, 85, 120, 95, 80, 75],
  },
  {
    id: "rl4",
    productId: "6",
    productTitle: "Portable Bluetooth Speaker IPX7",
    productImage: "https://readdy.ai/api/search-image?query=portable%20bluetooth%20speaker%20cylindrical%20black%20waterproof%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod6&orientation=squarish",
    seller: "TechVision Factory",
    sellerId: "techvision",
    commission: 10,
    price: 39.99,
    referralCode: "REF-JESS-004",
    referralUrl: "https://starbookprime.com/product/6?ref=REF-JESS-004",
    clicks: 654,
    conversions: 28,
    earnings: 111.97,
    pendingEarnings: 39.99,
    createdAt: "2026-04-01",
    lastClick: "2026-04-10",
    trend: "up",
    weeklyClicks: [40, 55, 70, 90, 110, 130, 145],
  },
  {
    id: "rl5",
    productId: "3",
    productTitle: "Smart LED Desk Lamp with USB-C",
    productImage: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20white%20minimalist%20design%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prod3&orientation=squarish",
    seller: "TechVision Factory",
    sellerId: "techvision",
    commission: 8,
    price: 28.99,
    referralCode: "REF-JESS-005",
    referralUrl: "https://starbookprime.com/product/3?ref=REF-JESS-005",
    clicks: 421,
    conversions: 15,
    earnings: 34.79,
    pendingEarnings: 6.96,
    createdAt: "2026-04-05",
    lastClick: "2026-04-09",
    trend: "up",
    weeklyClicks: [20, 35, 45, 60, 75, 90, 95],
  },
];
